export default __webpack_public_path__ + "static/resetPassword-854103b8208b59cb49309a17ee148e39.webp";